import { Edit } from 'almanac-ui/icons/16'
import { LinkPrompt } from 'common/Prose/Prompts/LinkPrompt/LinkPrompt'
import { CreateEditLinkCallbackFn } from 'common/Prose/Prompts/LinkPrompt/Types'
import { observer } from 'mobx-react-lite'
import { EditorView } from 'prosemirror-view'
import { ArticleFlat } from 'types'
import { ProseDropdownPrompt } from '../ProseDropdownPrompt/ProseDropdownPrompt'
import Styles from './LinkInlineFormatButton.module.scss'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { LinkDrawer } from 'common/Prose/Toolbar/MobileWriterFormatBar/LinkDrawer'
import { EditorViewProvider } from 'common/Prose/EditorProvider/EditorProviderContext'
import { AlmanacEditorState, AlmanacEditorStateContext } from 'stores/EditorState'
import store from 'redux/store'
import queryClient from 'queryClient'
import { Provider } from 'react-redux'
import { QueryClientProvider } from 'react-query'
import { getHistoryInstance } from 'hooks/useHistory'
import { Router } from 'react-router-dom'
import { InlineFormatButton } from 'components/InlineFormatBar/components/InlineFormatButton/InlineFormatButton'
import { useRootStore } from 'stores/RootStore'

type EditLinkInlineFormatButtonProps = {
  view: EditorView
  article: ArticleFlat
  defaults: { text: string; query: string }
  editCallback: CreateEditLinkCallbackFn
  removeLink: () => void
}

export const EditLinkInlineFormatButton = observer(function EditLinkInlineFormatButton({
  view,
  article,
  defaults,
  editCallback,
  removeLink,
}: EditLinkInlineFormatButtonProps) {
  const { isMobile } = useResponsiveDesign()
  const drawersStore = useRootStore().drawersStore

  if (isMobile) {
    return (
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <Router history={getHistoryInstance()}>
            <AlmanacEditorStateContext.Provider value={new AlmanacEditorState(view)}>
              <EditorViewProvider value={view}>
                <InlineFormatButton
                  onPress={() =>
                    drawersStore.openDrawer(LinkDrawer, {
                      initialQuery: defaults.query,
                      initialText: defaults.text,
                      onRemoveLink: removeLink,
                    })
                  }
                >
                  <Edit />
                </InlineFormatButton>
              </EditorViewProvider>
            </AlmanacEditorStateContext.Provider>
          </Router>
        </QueryClientProvider>
      </Provider>
    )
  }

  return (
    <ProseDropdownPrompt
      view={view}
      anchorChildren={<Edit />}
      label="Edit"
      promptContainerClassName={Styles.promptContainer}
      dropdownComponent={(close) => {
        const handleClose = () => {
          close()
          view.focus()
        }

        return (
          <LinkPrompt
            article={article}
            close={handleClose}
            initialText={defaults.text}
            defaults={defaults}
            callback={editCallback}
            removeLink={() => {
              removeLink()
              handleClose()
            }}
          />
        )
      }}
    />
  )
})
